export function tabs() {
    $('.tabs-holder .tabs-nav').on('click', 'a', function (e) {
        let tab = $(this).parent();
        let tabIndex = tab.index();
        let tabPanel = tab.closest('.tabs-holder');
        let tabPane = tabPanel.find('.tab').eq(tabIndex);

        tabPanel.find('.active').removeClass('active');
        tab.addClass('active');
        tabPane.addClass('active');
        e.preventDefault();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabs.js